<template>
	<div>
		<div class="my-4 px-4 group-body">
			<div>
				<GroupUsePermission @selected-use-permission-type="onUsePermissionChange" :group="group" />
				<GroupPermittedUses @selected-permitted-use="onPermittedUseChange" :group="group" />
			</div>
			<AnemicButton :loading="isSaving" @click="saveGroupChanges" :disabled="isSaveDisabled" class="save-button">Save changes</AnemicButton>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { createGroup, updateGroup } from '@/store/modules/accountGroups/actions';
import { groups, defaultGroupName } from '@/store/modules/accountGroups/getters';
import GroupUsePermission from '@/views/settings/groups/tabs/SyncedGroupPermissions/GroupUsePermission.vue';
import GroupPermittedUses from '@/views/settings/groups/tabs/SyncedGroupPermissions/GroupPermittedUses.vue';
export default {
	name: 'GroupPermissionsTab',
	components: {
		GroupUsePermission,
		GroupPermittedUses,
	},
	props: {
		group: { type: Object },
	},
	computed: {
		...mapGetters([groups.fullPath, defaultGroupName.fullPath]),
		isSaveDisabled() {
			return !this.didUsePermissionChange && !this.didPermittedUseChange;
		},
		didUsePermissionChange() {
			return this.usePermissionType !== this.group.access_type;
		},
		didPermittedUseChange() {
			return Object.keys(this.permittedUse).some((key) => this.permittedUse[key] != this.group.usage_preferences[key]);
		},
	},
	methods: {
		...mapActions([createGroup.fullPath, updateGroup.fullPath]),
		onUsePermissionChange(newV) {
			this.usePermissionType = newV;
		},
		onPermittedUseChange(newV) {
			this.permittedUse = newV;
		},
		async saveGroupChanges() {
			this.isSaving = true;
			try {
				await this[updateGroup.fullPath]({
					id: this.group.id,
					name: this.group.name,
					access_type: this.usePermissionType,
					usage_preferences: this.permittedUse,
				});
				this.$toast.success('Group updated');
			} catch {
				this.$toast.error(`Failed to update group, please try again`);
			} finally {
				this.isSaving = false;
			}
		},
	},
	created() {
		if (this.group) {
			this.usePermissionType = this.group.access_type;
			this.permittedUse = { ...this.group.usage_preferences };
		}
	},
	data: () => ({
		usePermissionType: undefined,
		permittedUse: undefined,
		isSaving: false,
	}),
};
</script>

<style scoped lang="scss">
.group-body {
	height: 350px !important;
	overflow: auto !important;
}
.save-button {
	width: 144px !important;
	height: 38px !important;
	font-size: 14px !important;
	border-radius: 3px !important;
	letter-spacing: 0px !important;
	color: var(--white) !important;
	font-weight: normal !important;
	border-color: transparent !important;
	background: var(--forth-color) !important;
}
</style>
